if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:newsletter-popup';
      }
    
      get submited() {
        return this.querySelector('.alert') !== null;
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        
        // Open modal if errors or success message exist
        if (this.submited) {
          this.load(1);
          return;
        }
    
        if (this.testMode || !this.getCookie(this.cookieName)) {
          this.load(this.delay);
        }
      }
    
      load(delay) {
        if (Shopify.designMode) return;

        // STOLAN S99 (Steve approved): exit-intent replaces the blind timer.
        // The old behaviour ran a timer and covered the hero 7 seconds after load.
        // Desktop : fire when the cursor leaves through the TOP of the viewport.
        // Touch   : no mouseout there, so fall back to deep scroll (70% of the document).
        // There is deliberately NO fallback timer. If a visitor neither leaves via the
        // top nor scrolls deep, they never see it. That is what exit-intent means.
        let done = false;

        const cleanup = () => {
          document.removeEventListener('mouseout', onMouseOut);
          window.removeEventListener('scroll', onScroll);
        };

        const fire = () => {
          if (done) return;
          done = true;
          cleanup();
          this.show();
        };

        const onMouseOut = (event) => {
          // relatedTarget null + clientY <= 0 means the pointer left through the viewport top
          if (!event.relatedTarget && event.clientY <= 0) fire();
        };

        const onScroll = () => {
          const doc = document.documentElement;
          const reach = (window.scrollY + window.innerHeight) / doc.scrollHeight;
          if (reach >= 0.7) fire();
        };

        document.addEventListener('mouseout', onMouseOut);
        window.addEventListener('scroll', onScroll, { passive: true });
      }
    
      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}
